import { render } from "./Employee-List-Item.vue?vue&type=template&id=7b70e894&scoped=true"
import script from "./Employee-List-Item.vue?vue&type=script&lang=js"
export * from "./Employee-List-Item.vue?vue&type=script&lang=js"

import "./Employee-List-Item.vue?vue&type=style&index=0&id=7b70e894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b70e894"]])

export default __exports__